import { render, staticRenderFns } from "./QuotationLetter.vue?vue&type=template&id=55c62149&scoped=true"
import script from "./QuotationLetter.vue?vue&type=script&lang=js"
export * from "./QuotationLetter.vue?vue&type=script&lang=js"
import style0 from "./QuotationLetter.vue?vue&type=style&index=0&id=55c62149&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c62149",
  null
  
)

export default component.exports